<ul class="submenu-action-list">
  <li *ngFor="let action of actions" class="submenu-action">
    <pulse-sidebar-action [action]="action"></pulse-sidebar-action>
  </li>
</ul>
